import script from "./WeeklyLeaderboard.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyLeaderboard.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyLeaderboard.vue?vue&type=style&index=0&id=666dacfa&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666dacfa"]])

export default __exports__